import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications';
import {Loader, validateGSTIN} from '../../utils/misc'
import {Glyphicon} from 'react-bootstrap'
import StateSelect from '../client/stateselect'
export default class AddSupplier extends React.Component {

  constructor() {
    super()
    this.state = {supplier:{name:"", phone:"",
                          email:"", gstin:"",
                          pan:"", code:"", vat:"",
                           website:"", is_sez:false,
                           address:"", country:"", state:"", city:"", pin:"", state_ui:{state_name:"", state_code:""},
                           same_as_biiling: true, notes:"",
                           shipping_address:"", shipping_country:"", shipping_state:"", shipping_city:"", shipping_pin:"", shipping_state_ui:{state_name:"", state_code:""},
                         }, loading:true}
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.mapShippingAddress = this.mapShippingAddress.bind(this)
    this.handleStateChange = this.handleStateChange.bind(this)
    this.handleShippingStateChage = this.handleShippingStateChage.bind(this)
    this.deleteSupplier = this.deleteSupplier.bind(this)
    this.sameAsBilling = this.sameAsBilling.bind(this)
  }

  deleteSupplier() {
    let confirmation = window.confirm('You are about to delete this client !')
    if(confirmation) {
      axios({
        url: '/delete_supplier/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.supplier
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted supplier successfully")
          setTimeout(()=>{
            if(this.state.mode === "edit") {
              this.props.history.goBack()
            }
            else {
                this.props.history.push("/suppliers/")
            }

          }, 700)
        }
      }).catch((err)=> {
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
          this.setState({deleteError: err.response.data.msg})
          NotificationManager.error(err.response.data.msg)
        }
      })
    }

  }


  componentDidMount() {


    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.supplier_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Supplier " + this.props.match.params.supplier_id
      this.getSupplier(this.props.match.params.supplier_id).then((response)=>{
        if(response.status===200) {


                    let supplier = response.data.supplier
                    supplier['state_ui'] = {state_name: supplier.state, state_code:supplier.state_code}
                    supplier['shipping_state_ui'] = {state_name: supplier.shipping_state, state_code:supplier.shipping_state_code}

          this.setState({supplier: supplier, loading:false,
            total_dn_value: response.data.total_dn_value,
             total_purchases_value:response.data.total_purchases_value, total_payments_value: response.data.total_payments_value})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Supplier "
        this.setState({loading:false})
    }

  }

  sameAsBilling(event) {
    const name = event.target.name;
    const value = event.target.checked
    this.modifyItemState(name, value)

    if(value) {
      this.mapShippingAddress()
    }
  }

  mapShippingAddress() {
    let supplier = this.state.supplier
    this.modifyItemState('shipping_address', supplier.address)
    this.modifyItemState('shipping_country', supplier.country)
    this.modifyItemState('shipping_state', supplier.state)
    this.modifyItemState('shipping_state_code', supplier.state_code)
    this.modifyItemState('shipping_city', supplier.city)
    this.modifyItemState('shipping_pin', supplier.pin)
    this.modifyItemState('shipping_state_ui': {state_name:supplier.state, state_code:supplier.state_code})
  }


  modifyItemState(key, value) {
        let currentItem = this.state.supplier
        currentItem[key] = value
        this.setState({
          supplier: currentItem
       });
  }

  handleStateChange(option) {

    this.modifyItemState('state', option.state_name)
    this.modifyItemState('state_code', option.state_code)
    this.modifyItemState('state_ui', option)

  }
  handleShippingStateChage(option) {

    this.modifyItemState('shipping_state', option.state_name)
    this.modifyItemState('shipping_state_code', option.state_code)
    this.modifyItemState('shipping_state_ui', option)

  }


  getSupplier(supplier_id) {
    return axios({
      url: '/get_supplier/?id='+supplier_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }


  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
   this.modifyItemState(name, value)
  }


  handleSubmit(event) {
    event.preventDefault()
    this.setState({submitting:true})
    let apiurl

    if(typeof this.state.mode !== "undefined" && this.state.mode === "edit"){
      apiurl = '/update_supplier/'
    }
    else {
      apiurl = '/create_new_supplier/'
    }
    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.supplier
    }).then((response)=> {
      this.setState({submitting:false})
      if(response.status === 200) {
        //this.props.dispatch(addingItemSuccess(response.data.item))
        if(typeof this.props.noredirect !== "undefined") {
          // if somebody says no redirect, then dont.
        }
        else if(typeof this.props.onAddCallback !== "undefined") {
          this.props.onAddCallback(response.data.supplier)
        }
        else {
          if(this.state.mode ==="edit") {
              NotificationManager.success("Updated supplier successfully")
          }
          else {
              NotificationManager.success("Created supplier successfully")
          }

        this.props.history.goBack()
        }
      }
    }).catch((err)=> {
      this.setState({submitting:false})

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        let error_response_data = err.response.data.error
        if(typeof error_response_data !== "undefined") {
          NotificationManager.error(error_response_data)
        }
      }

    })

  }




  render() {


    let submitButton = <input type="submit" className="btn btn-success" value="save" />
    if(this.state.submitting) {
      submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
    }


    let supplier = {}
    let validGstin, gstinFieldClass, gstinInvalidMsg
    if(typeof this.state.supplier !== "undefined" && this.state.supplier !== null) {
      supplier = this.state.supplier

      if(supplier.gstin) {
        validGstin  = validateGSTIN(supplier.gstin);
      }
    }

    if(supplier.gstin  && supplier.gstin.length>0 ) {
      if(validGstin) {
          validGstin =  <Glyphicon glyph="ok-circle" className="text-success" />
      }
      else {
          gstinInvalidMsg = "Invalid GSTIN"
          gstinFieldClass = "has-error"
      }
    }







    let form
    if(this.state.loading) {

      return  <Loader />
    }
    else {

      const leftForm = (
        <div >
            <div className="form-group">
        <label className="col-sm-3">
          Name <span>*</span>
        </label>
        <div className="col-sm-9">
            <input name="name" type="text" value={supplier.name} className="form-control input-sm" onChange={this.handleInputChange} required />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Phone
        </label>
        <div className="col-sm-9">
            <input name="phone" value={supplier.phone} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Email
        </label>
        <div className="col-sm-9">
            <input name="email" type="email" value={supplier.email} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className={"form-group " + gstinFieldClass}>
        <label className="col-sm-3">
          GSTIN {validGstin}
        </label>
        <div className="col-sm-9">
            <input name="gstin" type="text" value={supplier.gstin} className="form-control input-sm" onChange={this.handleInputChange}  />
            <span className="text-danger small">{gstinInvalidMsg}</span>
        </div>
            </div>


            <div className="form-group">
        <label className="col-sm-3">
          PAN
        </label>
        <div className="col-sm-9">
            <input name="pan" type="text" value={supplier.pan} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Supplier Code
        </label>
        <div className="col-sm-9">
            <input name="code" type="text" value={supplier.code} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          VAT
        </label>
        <div className="col-sm-9">
            <input name="vat" type="text" value={supplier.vat} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Website
        </label>
        <div className="col-sm-9">
            <input name="website" type="text" value={supplier.website} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>




        </div>
      )
      let shippingform


      if(!this.state.loading && !supplier.same_as_biiling) {


       shippingform = (<div>

        <div className="form-group">
          <label className="col-sm-3">
            Address
          </label>
          <div className="col-sm-9">
            <input name="shipping_address" value={supplier.shipping_address} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            City
          </label>
          <div className="col-sm-9">
            <input name="shipping_city" value={supplier.shipping_city} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            State
          </label>
          <div className="col-sm-9">

            <StateSelect value={supplier.shipping_state_ui} name="shipping_state" handleChange={this.handleShippingStateChage} />

          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            Country
          </label>
          <div className="col-sm-9">
            <input name="shipping_country" value={supplier.shipping_country} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            Pin
          </label>
          <div className="col-sm-9">
            <input name="shipping_pin" value={supplier.shipping_pin} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        </div>)

      }

      const rightForm = (<div>
        <div className="form-group">
          <label className="col-sm-3">
            Address
          </label>
          <div className="col-sm-9">
            <input name="address" type="text" value={supplier.address} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

                <div className="form-group">
                  <label className="col-sm-3">
                    City
                  </label>
                  <div className="col-sm-9">
                    <input name="city" type="text" value={supplier.city} className="form-control input-sm" onChange={this.handleInputChange}  />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-3">
                    State
                  </label>
                  <div className="col-sm-9">
                    <StateSelect value={supplier.state_ui} name="state" handleChange={this.handleStateChange} />
                  </div>
                </div>

        <div className="form-group">
          <label className="col-sm-3">
            Country
          </label>
          <div className="col-sm-9">
            <input name="country" type="text" value={supplier.country} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>


        <div className="form-group">
          <label className="col-sm-3">
            Pin
          </label>
          <div className="col-sm-9">
            <input name="pin" type="text" value={supplier.pin} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-9">
            <strong>Shipping Address</strong>
          </label>
        </div>

        <div className="form-group">
          <label className="col-sm-9">
              <input type="checkbox" name="same_as_biiling" checked={supplier.same_as_biiling} onChange={this.sameAsBilling} /> Same as billing address ?
          </label>
        </div>



        {shippingform}

      </div>)

      const notes = (
        <div className="form-group">
          <label className="col-sm-3">
            Notes
          </label>
          <div className="col-sm-9">
            <textarea name="notes" className="form-control" rows="3" value={supplier.notes} onChange={this.handleInputChange}></textarea>
          </div>
        </div>
        )

    form = (<form className="form-horizontal" onSubmit={this.handleSubmit}>

          <div className="form-group">
            <div className="col-md-6">
                {leftForm}
                {notes}
            </div>
            <div className="col-md-6">
              {rightForm}
            </div>
          </div>

          <div className="form-action-group text-right">
            {submitButton}
          </div>

        </form>)


        let pageHeader, deleteSupplierBtn, deleteError, pps
        if(this.state.mode === "edit") {

          deleteSupplierBtn = <button className="btn btn-danger" onClick={this.deleteSupplier}>Delete Supplier</button>

          pageHeader = <div className="row">
              <div className="col-sm-10">
                  <h3>{"Edit Supplier: " + supplier.name}</h3>
              </div>
              <div className="col-sm-2 text-right">
                {deleteSupplierBtn}
                {deleteError}
              </div>
          </div>

          pps = <div className="row">
              <div className="col-sm-3">
                <div className="panel panel-info">
                  <div className="panel-body text-center">
                    <div className="text-muted"><strong>Total Purchase Amount</strong></div>
                    <div> <h4>₹ {parseFloat(this.state.total_purchases_value).toFixed(2)}</h4> </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="panel panel-info">
                  <div className="panel-body text-center">
                    <div className="text-muted"> <strong>Total Payment Amount</strong></div>
                    <div> <h4>₹ {parseFloat(this.state.total_payments_value).toFixed(2)}</h4> </div>
                  </div>
                </div>

              </div>
              <div className="col-sm-3">
                <div className="panel panel-info">
                  <div className="panel-body text-center">
                    <div className="text-muted"> <strong>Total DebitNote Amount</strong></div>
                    <div> <h4>₹ {parseFloat(this.state.total_dn_value).toFixed(2)}</h4> </div>
                  </div>
                </div>

              </div>
              <div className="col-sm-3">
                <div className="panel panel-info">
                  <div className="panel-body text-center">
                    <div className="text-muted"> <strong>Net Due</strong></div>
                    <div> <h4>₹ { parseFloat(supplier.balance_amount).toFixed(2)}</h4> </div>
                  </div>
                </div>

              </div>
          </div>

        }
        else {
          pps =  <h3 >Create New Supplier</h3>
        }


        return <div>
        <section className="medium">
            {pageHeader}
        </section>
        <section className="small">
          {pps}
        </section>
          <div className="row">
            <div className="col-xs-12">
              {form}
            </div>
          </div>


        </div>
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/supplier/addsuppliernew.js